import {BasePqForm} from "biz-ts/src/api/Paging";

export class DtaskPqForm extends BasePqForm {
    deviceId!: number

    constructor(deviceId: number) {
        super();
        this.deviceId = deviceId;
    }
}

export class DtaskGenPqForm extends BasePqForm {
    deviceId!: number

    constructor(deviceId: number) {
        super();
        this.deviceId = deviceId;
    }
}
